import type { SupVaultReward } from "@/types";
import React from "react";

import RewardValue from "@/components/Ui/Label/Rewards/Value";
import { SupAssetLabel, SupText } from "@repo/core-ui";

interface UiLabelRewardsTooltipLineProps {
  reward: SupVaultReward;
  hideRewards?: boolean;
}

export default function UiLabelRewardsTooltipLine({ reward, hideRewards }: UiLabelRewardsTooltipLineProps) {
  return (
    <div className="flex min-h-8 max-w-[280px] flex-col justify-center space-y-1 self-stretch px-1 py-2">
      <div className="inline-flex items-center justify-between space-x-1 self-stretch">
        <SupAssetLabel className="w-fit items-center gap-1" label={<SupText variant="subtitle2">{reward.symbol}</SupText>}>
          <img src={reward.logo} className="h-4 w-4 rounded-full object-cover" alt={reward.symbol} />
        </SupAssetLabel>
        <RewardValue reward={reward} />
      </div>
      {!hideRewards && reward.remarks !== "" && (
        <div className="pl-5">
          <SupText variant="caption" family="mono" className="text-[10px]">
            {reward.remarks}
          </SupText>
        </div>
      )}
    </div>
  );
}
